import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import cart from "./modules/cart";
import category from "./modules/category";
import company from "./modules/company";
import feed from "./modules/feed";
import product from "./modules/product";
import user from "./modules/user";
import wishlist from "./modules/wishlist";
import userManager from "./modules/userManager";
import adminSidebar from "./modules/adminSidebar";
import systemMessage from "./modules/systemMessage";
import adminPointPrograms from "./modules/adminPointPrograms";
import adminAddPoint from "./modules/adminAddPoints";
import createPersistedState from "vuex-persistedstate";
import adminBatchUserUploadTool from "./modules/adminBatchUserUploadTool";
import adminBatchUserCreateTool from "./modules/adminBatchUserCreateTool";
import adminBatchPointUpload from "./modules/adminBatchPointUpload";
import loginsAndOrdersReport from "./modules/loginsAndOrdersReport";
import divvyAdminSidebar from "./modules/divvyAdmin/divvyAdminSidebar";
import sidebarModules from "./modules/divvyAdmin/sidebarModules";
import manageSuppliers from "./modules/divvyAdmin/manageSuppliers";
import manageClients from "./modules/divvyAdmin/manageClients";
import taxReport from "./modules/taxReport";
import transactionReport from "./modules/transactionReport";
import p4pDashboard from "./modules/p4pDashboard";
import pointsRemainingByUnitData from "./modules/dashboard-pointsRemaining";
import loginDashboard from "./modules/loginDashboard";
import businessUnits from "./modules/divvyAdmin/businessUnits";
import customers from "./modules/divvyAdmin/customers";
import manageProducts from "./modules/divvyAdmin/manageProducts";
import manageUsers from "./modules/divvyAdmin/manageUsers";
import generateExcel from "./modules/generateExcel-report";
import clientBlogs from "./modules/clientBlogs-communication";
import sendEmail from "./modules/sendEmail-users";
import divvyCategory from "./modules/divvyAdmin/divvyCategory";
import manageSystemUsers from "./modules/divvyAdmin/divvySystemUsers";
import shippingSearch from "./modules/divvyAdmin/shippingSearch";
import manageRoles from "./modules/divvyAdmin/manageRoles";
import customerOrders from "./modules/divvyAdmin/customerOrders";
import excludedKeywords from "./modules/divvyAdmin/excludedKeywords";
import generalLookup from "./modules/divvyAdmin/generalLookup";
import batchProcess from "./modules/divvyAdmin/batchProcess";
import categories from "./modules/divvyAdmin/categories";
import divvySystemMessage from "./modules/divvyAdmin/divvySystemMessage";
import orderDetails from "./modules/divvyAdmin/customerOrders-orderDetails";
import settings from "./modules/settings";
import faxEmail from "./modules/divvyAdmin/faxEmail";
import orders from "./modules/orders"
import payment from "./modules/hc360/hc360-payment";
import transactions from "./modules/hc360/hc360-transactions";
import invoices from "./modules/hc360/hc360-invoices";
import cloneClient from "./modules/hc360/hc360-cloneClient";
import statusBar from "./modules/statusBar";
import contact from "./modules/contact";
import concierge from "./modules/concierge";
Vue.use(Vuex);

const addPointsState = createPersistedState({
  paths: ["adminAddPoint"],
});

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== "production",
  state: {},
  mutations: {},
  actions: {},
  modules: {
    auth: auth,
    cart: cart,
    contact: contact,
    concierge: concierge,
    category: category,
    company: company,
    feed: feed,
    product: product,
    user: user,
    wishlist: wishlist,
    userManager: userManager,
    adminSidebar: adminSidebar,
    systemMessage: systemMessage,
    adminPointPrograms: adminPointPrograms,
    adminAddPoint: adminAddPoint,
    adminBatchUserUploadTool: adminBatchUserUploadTool,
    adminBatchPointUpload: adminBatchPointUpload,
    divvyAdminSidebar: divvyAdminSidebar,
    adminBatchUserCreateTool: adminBatchUserCreateTool,
    sidebarModules: sidebarModules,
    manageSuppliers: manageSuppliers,
    loginsAndOrdersReport: loginsAndOrdersReport,
    manageClients: manageClients,
    taxReport: taxReport,
    transactionReport: transactionReport,
    p4pDashboard: p4pDashboard,
    pointsRemainingByUnitData: pointsRemainingByUnitData,
    loginDashboard: loginDashboard,
    businessUnits: businessUnits,
    customers: customers,
    manageProducts: manageProducts,
    manageUsers: manageUsers,
    generateExcel: generateExcel,
    clientBlogs: clientBlogs,
    sendEmail: sendEmail,
    divvyCategory: divvyCategory,
    manageSystemUsers: manageSystemUsers,
    shippingSearch: shippingSearch,
    manageRoles: manageRoles,
    customerOrders: customerOrders,
    excludedKeywords: excludedKeywords,
    generalLookup: generalLookup,
    batchProcess: batchProcess,
    categories: categories,
    divvySystemMessage: divvySystemMessage,
    orderDetails: orderDetails,
    settings: settings,
    faxEmail: faxEmail,
    orders: orders,
    payment: payment,
    transactions: transactions,
    invoices: invoices,
    cloneClient: cloneClient,
    statusBar: statusBar
  },
  plugins: [addPointsState],
});
